import { render } from "./ConsultantCreationDialog.vue?vue&type=template&id=820ead1a"
import script from "./ConsultantCreationDialog.vue?vue&type=script&lang=js"
export * from "./ConsultantCreationDialog.vue?vue&type=script&lang=js"

import "../styles/ConsultantCreationDialog.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__